import { useState } from 'react'
import { Link, Outlet, useNavigate } from 'react-router-dom'
import { MathGate } from './MathGate'

export function ParentLayout() {
  const [unlocked, setUnlocked] = useState(false)
  const navigate = useNavigate()

  const handleSuccess = () => setUnlocked(true)
  const handleCancel = () => navigate('/')

  if (!unlocked) {
    return <MathGate onSuccess={handleSuccess} onCancel={handleCancel} />
  }

  return (
    <div className="page">
      <nav style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 24, justifyContent: 'center' }}>
        <Link to="/parent" className="btn-secondary" style={{ textDecoration: 'none' }}>Products</Link>
        <Link to="/parent/qr" className="btn-secondary" style={{ textDecoration: 'none' }}>QR Export</Link>
        <Link to="/parent/settings" className="btn-secondary" style={{ textDecoration: 'none' }}>Settings</Link>
        <Link to="/" className="btn-secondary" style={{ textDecoration: 'none' }}>Exit Parent</Link>
      </nav>
      <Outlet />
    </div>
  )
}
